
import { Vue } from "vue-class-component";

export default class Stats extends Vue {}
